import React from "react";
import 'stylesheets/layout.scss';
import 'stylesheets/fonts.scss';
import './DetailChildCardHeader.scss';
import presenter from "pages/ScheduleCalendar/duck/presenter";
import allUsersSlice from "App/duck/slices/allUsers";
import displayLogic from "pages/ScheduleCalendar/duck/displayLogic";

export function DetailChildCardHeaderComponent ({shift, allUsers, selectedApplicant}) {

   const featuredUser = presenter.featuredUserForShiftDetailHeader(shift, allUsers)
   const slogan = presenter.sloganForShiftDetailHeader(shift, allUsers)
   const singleUserToDisplay = presenter.singleUserToDisplay(shift, allUsers)
   const leftUserToDisplay = presenter.leftUserToDisplay(shift, allUsers)
   const rightUserToDisplay = presenter.rightUserToDisplay(shift, allUsers, selectedApplicant)

   const statusTag = presenter.statusTagForShiftDetailHeader(shift, selectedApplicant)
   const shouldShowSingleAvatar = displayLogic.shouldShowSingleHeaderAvatar(shift)
   const tagClassName= presenter.statusTagClassNameForShiftDetailHeader(shift, selectedApplicant)

//    console.log(JSON.stringify(statusTag));
    return (
         <div className="child-card text-center">
            { shouldShowSingleAvatar && <img className="pic single-pic br-50" src={presenter.getUserAvatar(singleUserToDisplay)}></img> }
            { !shouldShowSingleAvatar && <div className="pic-group">
                <img className="pic left-pic br-50" src={presenter.getUserAvatar(leftUserToDisplay)}></img> 
                <img className="pic right-pic br-50" src={presenter.getUserAvatar(rightUserToDisplay)}></img> 
            </div>}
            <label className={"stat-label ff-bold " + tagClassName}>{statusTag}</label>
            <label className="ff-semibold fs14">{presenter.getName(featuredUser)}</label>
            <label className="ff-regular fs14">{slogan}</label>
        </div>
    )
}

export default DetailChildCardHeaderComponent 
